<template>
    <div class="sort-box" :class="{'d-xl-none': hideDesktop}">
        <div class="form-group">
            <label for="sort">Sort by</label>
            <div class="pretty-select">
                <select id="sort" name="variant" v-model="sortOrder">
                    <option v-if="full" value="make-asc">Make (A-Z) </option>
<!--                    <option v-if="full" value="make-desc">Make (Z-A) </option>-->

                    <option v-if="full" value="range-asc">Model (A-Z) </option>
<!--                    <option v-if="full" value="range-desc">Model (Z-A) </option>-->

                    <option v-if="full" value="link-asc">Vehicle name (A-Z) </option>
<!--                    <option v-if="full" value="link-desc">Vehicle (high to low) </option>-->

                    <option v-if="full" value="offer-desc">Offer </option>

                    <option v-if="full" value="fuel-asc">Fuel (A-Z) </option>
<!--                    <option v-if="full" value="fuel-desc">Fuel (Z-A) </option>-->

                    <option v-if="full" value="transmission-asc">Transmission (A-Z) </option>
<!--                    <option v-if="full" value="transmission-desc">Transmission (Z-A) </option>-->

                    <option value="finance-asc">Price (low to high) </option>
                    <option value="finance-desc">Price (high to low) </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Sort",

        props: {
            hideDesktop: {
                type: Boolean,
                default: false
            },

            full: {
                type: Boolean,
                default: false
            },
        },

        data(){
            return {
                sortOrder: 'finance-asc'
            }
        },

        watch: {
            sortOrder: function() {
                this.$emit('orderChange', this.sortOrder)
            }
        }

    }
</script>

<style scoped lang="stylus">
    .sort-box
        display flex
        justify-content flex-end
        @media (max-width: 768px)
            justify-content left
        .form-group
            width 200px
</style>